// src/pages/Team.jsx
import React from "react";
import Footer from "../components/Footer";


const team = [
  {
    name: "Ömer H. Omar",
    role: "Co-founder, CEO",
    image: "/OHO1.jpg",
	link: "https://www.linkedin.com/in/omerhomar/",
    group: "Leadership",
  },
  {
    name: "Alessandro Troisi",
    role: "Co-founder, Head of STAB",
    image: "/AT.jpg",
	link: "https://uk.linkedin.com/in/alessandro-troisi-043a46243/",
    group: "Leadership",
  },
  {
    name: "Tony Travers",
    role: "Chairman",
    image: "/TT1.jpg",
	link: "https://uk.linkedin.com/in/tony-travers-81101b10/",
    group: "Leadership",
  },
    {
    name: "Simon Tuley",
    role: "Financial Advisor",
    image: "/simon.jpg",
	link: "https://www.linkedin.com/in/simon-tuley-b812322a/",
    group: "Leadership",
  },
  {
    name: "Tobias Neumann",
    role: "Nanomatch",
    image: "/TN1.jpg",
	link: "https://de.linkedin.com/in/tobias-neumann-4b8477122/",
    group: "Science and Technology Advisory Board (STAB)",
  },
  {
    name: "Timo Strunk",
    role: "Nanomatch",
    image: "/TS1.jpg",
    group: "Science and Technology Advisory Board (STAB)",
  },
  {
    name: "Dávid Havasi",
    role: "Mcule",
    image: "/DH.jpg",
	link: "https://hu.linkedin.com/in/davies-havasi/",
    group: "Science and Technology Advisory Board (STAB)",
  },
  {
    name: "Attila Wootsch",
    role: "Mcule",
    image: "/AW.jpg",
	link: "https://hu.linkedin.com/in/attilawootsch/",
    group: "Science and Technology Advisory Board (STAB)",
  },
    {
    name: "Abdel-Rahim Abdalla",
    role: "Lead Engineer",
    image: "/abdel1.jpg",
    group: "Technical Team",
  },
      {
    name: "Alfonso Gambino",
    role: "AI Engineer",
    image: "/alfonso.jpg",
    group: "Technical Team",
  },
      {
    name: "Opeyemi Oyeleke",
    role: "Full-Stack Engineer",
    image: "/ope.jpg",
    group: "Technical Team",
  },
      {
    name: "Hannah Wood",
    role: "Computational Chemist",
    image: "/hannah.jpg",
    group: "Technical Team",
  },
];

export default function Team() {
  const groups = ["Leadership", "Technical Team", "Science and Technology Advisory Board (STAB)"];

  return (
    <>
    <section className="min-h-screen py-20 px-6 sm:px-8 bg-[#1A1631] text-white">
      <div className="max-w-5xl mx-auto">
        <a
          href="/"
          className="text-[#EF7C34] hover:underline text-sm flex items-center mb-6"
        >
          <span className="mr-2 text-lg">←</span> Back to main site
        </a>

        <h1 className="text-4xl md:text-5xl font-bold mb-8">
          <span className="bg-gradient-to-r from-[#EF7C34] to-[#F89B3F] bg-clip-text text-transparent">
            Our Team
          </span>
        </h1>

        <p className="text-lg text-slate-300 mb-12 max-w-2xl">
          Meet the leadership and scientific experts behind Apoello and the DiaDEM<sup>™</sup> platform.
        </p>

        {groups.map((group) => (
          <div key={group} className="mb-12">
            <h2 className="text-2xl font-semibold text-orange-300 mb-6">{group}</h2>
            <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3">
              {team
                .filter((member) => member.group === group)
                .map((member, idx) => (
                  <div
                    key={idx}
                    className="bg-[#2A2444]/60 p-4 border border-[#EF7C34]/20 rounded-xl shadow hover:shadow-orange-500/20 transition-all flex flex-col items-center text-center"
                  >
                    <img
                      src={member.image}
                      alt={member.name}
                      className="w-28 h-28 rounded-full object-cover mb-4 border-2 border-orange-300"
                    />
                    <h3 className="text-lg font-semibold text-white">{member.name}</h3>
                    <p className="text-sm text-slate-400 italic">{member.role}</p>
					<p className="text-sm text-blue-400 italic">{member.link && <a href={member.link} target="_blank" rel="noopener noreferrer" className="text-orange-200 underline hover:text-orange-100">LinkedIn</a>} </p>
                  </div>
                ))}
            </div>
          </div>
        ))}
      </div>
    </section>
          {/* ✅ Minimal Footer always sits outside main content */}
      <Footer />
    </>
  );
}
